module.exports = __webpack_public_path__ + "static/media/James B. Weaver - 1880.f7be246f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/James B. Weaver - 1880.jpg
// module id = 498
// module chunks = 0